import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'How do I choose the right online casino?',
      answer: 'Look for UK Gambling Commission licensing, transparent terms and conditions, positive player reviews, fast withdrawal times, and a diverse game selection that matches your preferences. Our reviews break down these factors to make your decision easier.'
    },
    {
      question: 'Are online casino bonuses worth claiming?',
      answer: 'Welcome bonuses can significantly boost your starting balance, but always read the wagering requirements carefully. A lower bonus with reasonable terms often beats a larger one with strict conditions. We highlight the best value bonuses in our reviews.'
    },
    {
      question: 'How long do casino withdrawals take?',
      answer: 'Withdrawal times vary by casino and payment method. E-wallets like PayPal and Skrill typically process within 24 hours, while bank transfers can take 3-5 business days. We test and report actual withdrawal speeds for each casino we review.'
    },
    {
      question: 'Is online casino gaming safe and fair?',
      answer: 'Reputable UK casinos use Random Number Generators (RNG) that are regularly tested by independent auditors. Look for certifications from eCOGRA or similar bodies. All casinos we recommend hold valid UK Gambling Commission licenses.'
    },
    {
      question: 'Can I play casino games on my mobile?',
      answer: 'Absolutely. Most modern online casinos offer fully optimized mobile experiences through responsive websites or dedicated apps. You can access slots, table games, and live dealer options on smartphones and tablets without compromising quality.'
    },
    {
      question: 'What payment methods are available?',
      answer: 'UK players typically have access to debit cards (Visa, Mastercard), e-wallets (PayPal, Skrill, Neteller), bank transfers, and prepaid cards. Many casinos also support Apple Pay and Google Pay for faster deposits. Check individual casino reviews for full payment options.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-brown-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-brown-700">
            Get answers to the most common questions about online casino gaming
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-brown-600 to-beige-400 rounded-full mx-auto mt-6"></div>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`glass-strong rounded-2xl overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'shadow-xl' : 'shadow-md'
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-white/20 transition-colors"
              >
                <span className="text-lg font-semibold text-brown-900 pr-4">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 text-brown-700">
                  {openIndex === index ? (
                    <ChevronUp className="w-6 h-6" />
                  ) : (
                    <ChevronDown className="w-6 h-6" />
                  )}
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <div className="pt-2 border-t border-brown-200/50">
                    <p className="text-brown-700 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

